<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div id="Contacts">
    <div class="giga-content_header">
      <div class="content-header_wrap">
        <h3 class="content-header_title">Team GIGAWHAT</h3>
      </div>
    </div>
    <div class="giga-content_container">
      <page-loader v-if="loading" :hasHeader="true"></page-loader>

      <div v-if="!loading" class="row">
        <!-- CONSULTANT -->
        <contact-card
          v-if="getContacts && getContacts.consultant"
          :lastname="getContacts.consultant.lastName"
          :firstname="getContacts.consultant.firstName"
          profile="Consultant"
          :email="getContacts.consultant.mail"
          :phone="getContacts.consultant.telephone"
          :sendEmail="true"
          classes="col-lg-4"
        >
        </contact-card>

        <!-- COMMERCIAL -->
        <contact-card
          v-if="getContacts && getContacts.commercial"
          :lastname="getContacts.commercial.lastName"
          :firstname="getContacts.commercial.firstName"
          profile="Commercial"
          :email="getContacts.commercial.mail"
          :phone="getContacts.commercial.telephone"
          :sendEmail="true"
          classes="col-lg-4"
        >
        </contact-card>

        <!-- COMMERCIAL -->
        <contact-card
          v-if="getContacts && getContacts.projectEngineer"
          :lastname="getContacts.projectEngineer.lastName"
          :firstname="getContacts.projectEngineer.firstName"
          profile="CEN"
          :email="getContacts.projectEngineer.mail"
          :phone="getContacts.projectEngineer.telephone"
          :sendEmail="true"
          classes="col-lg-4"
        >
        </contact-card>
        <!-- Support IT -->
        <contact-card
          lastname="SupportGIGAWHAT"
          firstname=""
          profile="Support IT"
          email="gigawhat@leyton.com"
          :sendEmail="true"
          classes="col-lg-4"
        >
        </contact-card>
        <!-- GENERIC EMAIL -->
        <contact-card
            v-if="getContacts && getContacts.genericEmail"
            lastname="CONTACT LEYTON "
            firstname=""
            profile="Mail générique"
            :email="getContacts.genericEmail"
            :sendEmail="true"
            classes="col-lg-4"
        >
        </contact-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import PageLoader from "../../components/static/pageLoader.vue";
import contactCard from "./contactCard";
import ContactCard from "./contactCard.vue";
export default {
  name: "Contacts",
  components: { PageLoader, contactCard, ContactCard },
  computed: {
    ...mapGetters("contact", ["getContacts"]),
    ...mapGetters("leftsidebar", { sidebarShowStatus: "getSidebarShowStatus" }),
    ...mapGetters("loader", { loading: "getLoading" })
  },
  methods: {
    ...mapActions("contact", ["getContactsAction"]),
    ...mapMutations({
      toggleSidebar: "leftsidebar/toggleSidebar",
      setSidebarShow: "leftsidebar/setSidebarShow"
    })
  },
  async created() {
    await this.getContactsAction();
  },
  mounted() {
    if (!this.sidebarShowStatus) {
      this.setSidebarShow(true);
      this.toggleSidebar();
    }
  }
};
</script>

<style lang="scss" scoped>
.attribute-height {
  min-height: 33px;
}
</style>
